export const TOOGLE_DARK_MODE = 'TOOGLE_DARK_MODE';
